/* =========================================================
SEMI LOCATOR — SHOWROOM V9
PANEL MINIMIZE SYSTEM + POLY DETAIL SHOWROOM ENGINE
Replace current sim-showroom.js with this full file.

Adds:
- Minimize buttons to UI panels
- Floating restore dock
- Mobile-friendly panel collapse
- Keeps V7 poly truck / cinematic showroom
========================================================= */

(function(){
"use strict";

/* =========================================================
PANEL MINIMIZE SYSTEM
========================================================= */

function installPanelMinimizeSystem(){

if(window.__SLX_SHOWROOM_PANEL_MIN__) return;
window.__SLX_SHOWROOM_PANEL_MIN__ = true;

var style = document.createElement("style");
style.innerHTML = ""
+ ".slx-min-btn{position:absolute;right:14px;top:12px;width:32px;height:28px;border-radius:10px;border:1px solid rgba(120,220,255,.22);background:rgba(4,12,22,.88);color:#9ee8ff;font-weight:900;cursor:pointer;z-index:80;box-shadow:0 0 18px rgba(0,180,255,.12);}"
+ ".slx-min-btn:active{transform:scale(.96);}"
+ ".slx-card-minimized{display:none!important;}"
+ ".slx-panel-restore-dock{position:absolute;left:50%;bottom:112px;transform:translateX(-50%);z-index:95;display:flex;gap:10px;flex-wrap:wrap;align-items:center;justify-content:center;max-width:calc(100% - 28px);pointer-events:auto;}"
+ ".slx-restore-pill{border:1px solid rgba(120,220,255,.24);background:rgba(4,12,22,.88);color:#dff7ff;border-radius:999px;padding:10px 14px;font-size:11px;font-weight:900;letter-spacing:1px;cursor:pointer;box-shadow:0 0 18px rgba(0,180,255,.14);backdrop-filter:blur(10px);}"
+ ".slx-restore-pill:hover{border-color:#55d8ff;box-shadow:0 0 22px rgba(0,180,255,.28);}"
+ ".slx-show-card,.slxCard{position:relative;}"
+ ".slx-hud-min-btn{position:absolute;right:12px;top:10px;width:30px;height:26px;border-radius:10px;border:1px solid rgba(120,220,255,.22);background:rgba(4,12,22,.88);color:#9ee8ff;font-weight:900;cursor:pointer;}"
+ "@media(max-width:700px){.slx-panel-restore-dock{bottom:86px}.slx-restore-pill{padding:9px 12px;font-size:10px}.slx-min-btn{width:34px;height:30px}}";
document.head.appendChild(style);

var stage = document.getElementById("slxThreeStage");
var app = document.getElementById("slxShowroomV2") || document.body;

var dock = document.createElement("div");
dock.className = "slx-panel-restore-dock";
dock.id = "slxPanelRestoreDock";

if(stage){
stage.appendChild(dock);
}else{
app.appendChild(dock);
}

function getPanelTitle(card){
var t = card.querySelector(".slxCardTitle");
if(t && t.innerText){ return t.innerText; }

var t2 = card.querySelector(".slx-card-title");
if(t2 && t2.innerText){ return t2.innerText; }

var active = card.querySelector(".slxTruckName");
if(active && active.innerText){ return "ACTIVE TRUCK"; }

return "PANEL";
}

function addMinButton(card,index){
if(!card || card.getAttribute("data-slx-min-ready") === "1") return;

card.setAttribute("data-slx-min-ready","1");

var title = getPanelTitle(card);
var id = "slxPanel_" + index + "_" + Math.floor(Math.random()*99999);

card.setAttribute("data-slx-panel-id",id);

var btn = document.createElement("button");
btn.type = "button";
btn.className = "slx-min-btn";
btn.innerHTML = "–";
btn.setAttribute("aria-label","Minimize " + title);

btn.onclick = function(e){
e.preventDefault();
e.stopPropagation();

card.className += " slx-card-minimized";
addRestorePill(id,title,card);
};

card.appendChild(btn);
}

function addRestorePill(id,title,card){
if(!dock) return;

var existing = document.querySelector('[data-restore-id="'+id+'"]');
if(existing) return;

var pill = document.createElement("button");
pill.type = "button";
pill.className = "slx-restore-pill";
pill.innerHTML = title;
pill.setAttribute("data-restore-id",id);

pill.onclick = function(e){
e.preventDefault();
e.stopPropagation();

card.className = card.className.replace(" slx-card-minimized","");
card.className = card.className.replace("slx-card-minimized","");

if(pill.parentNode){
pill.parentNode.removeChild(pill);
}
};

dock.appendChild(pill);
}

var cards = document.querySelectorAll(".slxCard,.slx-show-card");
for(var i=0;i<cards.length;i++){
addMinButton(cards[i],i);
}

/* Minimize V8/V9 Freight Horizon HUD if present later */
setTimeout(function(){
var huds = document.querySelectorAll(".slx-v9-hud,.slx-v8-hud");
for(var h=0;h<huds.length;h++){
addMinButton(huds[h],100+h);
}
},800);

}

/* =========================================================
SHOWROOM V9 3D ENGINE
========================================================= */

function boot(){

if(window.__SLX_SHOWROOM_V9__) return;

var container = document.getElementById("slxThreeStage");
if(!container || !window.THREE) return;

window.__SLX_SHOWROOM_V9__ = true;

installPanelMinimizeSystem();

var scene = new THREE.Scene();
scene.fog = new THREE.Fog(0x020611,18,120);

var w = container.clientWidth || window.innerWidth;
var h = container.clientHeight || 720;

var camera = new THREE.PerspectiveCamera(45,w/h,0.1,1000);
camera.position.set(0,4.9,20);

var renderer = new THREE.WebGLRenderer({
antialias:true,
alpha:true
});

renderer.setPixelRatio(window.devicePixelRatio || 1);
renderer.setSize(w,h);
renderer.shadowMap.enabled = true;

if(renderer.outputColorSpace !== undefined){
renderer.outputColorSpace = THREE.SRGBColorSpace;
}

container.innerHTML = "";
container.appendChild(renderer.domElement);

/* reinstall dock after canvas clear */
installPanelMinimizeSystem();

/* =========================================================
HUD CARD — MINIMIZABLE
========================================================= */

var hud = document.createElement("div");
hud.className = "slx-v9-hud";
hud.style.position = "absolute";
hud.style.top = "145px";
hud.style.right = "34px";
hud.style.width = "255px";
hud.style.padding = "18px";
hud.style.borderRadius = "20px";
hud.style.background = "rgba(3,10,18,.72)";
hud.style.border = "1px solid rgba(120,220,255,.18)";
hud.style.backdropFilter = "blur(12px)";
hud.style.color = "#dff7ff";
hud.style.fontFamily = "Arial";
hud.style.zIndex = "70";
hud.style.boxShadow = "0 0 34px rgba(0,180,255,.12)";
hud.innerHTML = ""
+ "<button type='button' class='slx-hud-min-btn' id='slxHudMinBtn'>–</button>"
+ "<div style='font-size:12px;letter-spacing:3px;color:#7ce7ff;margin-bottom:12px;font-weight:900;'>FREIGHT HORIZON</div>"
+ "<div style='font-size:28px;font-weight:900;margin-bottom:8px;'>TITAN GRID</div>"
+ "<div style='opacity:.86;line-height:1.45;font-size:14px;'>Signal density increasing across southeast corridor.<br><br>Weather stable.<br>Fleet visibility +14%.<br>Night freight activity elevated.</div>";
container.appendChild(hud);

var hudMinBtn = document.getElementById("slxHudMinBtn");
if(hudMinBtn){
hudMinBtn.onclick = function(e){
e.preventDefault();
e.stopPropagation();

hud.style.display = "none";

var dock = document.getElementById("slxPanelRestoreDock");
if(dock){
var pill = document.createElement("button");
pill.className = "slx-restore-pill";
pill.type = "button";
pill.innerHTML = "FREIGHT HORIZON";
pill.onclick = function(){
hud.style.display = "block";
if(pill.parentNode){ pill.parentNode.removeChild(pill); }
};
dock.appendChild(pill);
}
};
}

/* =========================================================
LIGHTS
========================================================= */

scene.add(new THREE.AmbientLight(0xa8e8ff,2.15));

var key = new THREE.SpotLight(0xffffff,6.5,160,0.48,0.4,1);
key.position.set(-12,18,12);
key.castShadow = true;
scene.add(key);

var cyan = new THREE.PointLight(0x00d4ff,9.5,220);
cyan.position.set(0,5.2,3);
scene.add(cyan);

var rim = new THREE.PointLight(0x7ce7ff,4.4,140);
rim.position.set(13,5,-14);
scene.add(rim);

var redAlert = new THREE.PointLight(0xff3030,0,170);
redAlert.position.set(0,4,0);
scene.add(redAlert);

var frontWhite = new THREE.PointLight(0xffffff,2.4,120);
frontWhite.position.set(-9,1.6,5);
scene.add(frontWhite);

/* =========================================================
MATERIALS
========================================================= */

var titanBody = new THREE.MeshStandardMaterial({
color:0x121b25,
metalness:0.96,
roughness:0.12
});

var darkTrim = new THREE.MeshStandardMaterial({
color:0x070b10,
metalness:0.92,
roughness:0.18
});

var chrome = new THREE.MeshStandardMaterial({
color:0xeaf4ff,
metalness:1,
roughness:0.05
});

var glass = new THREE.MeshStandardMaterial({
color:0x8ef0ff,
metalness:1,
roughness:0.025,
transparent:true,
opacity:0.72
});

var tire = new THREE.MeshStandardMaterial({
color:0x050505,
metalness:0.18,
roughness:0.92
});

var glowMat = new THREE.MeshBasicMaterial({color:0x12dcff});
var amberMat = new THREE.MeshBasicMaterial({color:0xffb347});
var whiteMat = new THREE.MeshBasicMaterial({color:0xe9fbff});
var redMat = new THREE.MeshBasicMaterial({color:0xff3030});

/* =========================================================
HELPERS
========================================================= */

function addTo(group,mesh){
mesh.castShadow = true;
mesh.receiveShadow = true;
group.add(mesh);
return mesh;
}

function box(group,w,h,d,x,y,z,mat){
var m = new THREE.Mesh(new THREE.BoxGeometry(w,h,d),mat);
m.position.set(x,y,z);
return addTo(group,m);
}

function cyl(group,rt,rb,h,seg,x,y,z,mat,rz){
var m = new THREE.Mesh(new THREE.CylinderGeometry(rt,rb,h,seg),mat);
m.position.set(x,y,z);
if(rz !== undefined){m.rotation.z = rz;}
return addTo(group,m);
}

function bevelBox(group,w,h,d,x,y,z,mat){
var geo = new THREE.BoxGeometry(w,h,d,2,2,2);
var m = new THREE.Mesh(geo,mat);
m.position.set(x,y,z);
return addTo(group,m);
}

/* =========================================================
SHOWROOM FLOOR
========================================================= */

var floor = new THREE.Mesh(
new THREE.CircleGeometry(17.5,140),
new THREE.MeshStandardMaterial({
color:0x06121d,
metalness:1,
roughness:0.1
})
);

floor.rotation.x = -Math.PI/2;
floor.position.y = -2.2;
scene.add(floor);

function ring(inner,outer,color,opacity){
var r = new THREE.Mesh(
new THREE.RingGeometry(inner,outer,120),
new THREE.MeshBasicMaterial({
color:color,
transparent:true,
opacity:opacity,
side:THREE.DoubleSide
})
);
r.rotation.x = -Math.PI/2;
r.position.y = -2.15;
scene.add(r);
return r;
}

var outerRing = ring(11.2,11.62,0x00d4ff,0.46);
var innerRing = ring(6.25,6.52,0x7ce7ff,0.23);

/* soft showroom pulse */
var pulse = document.createElement("div");
pulse.style.position = "absolute";
pulse.style.left = "50%";
pulse.style.top = "50%";
pulse.style.width = "520px";
pulse.style.height = "520px";
pulse.style.transform = "translate(-50%,-50%)";
pulse.style.borderRadius = "50%";
pulse.style.background = "radial-gradient(circle, rgba(0,212,255,.14) 0%, rgba(0,212,255,0) 70%)";
pulse.style.pointerEvents = "none";
pulse.style.zIndex = "2";
pulse.style.animation = "slxShowPulse 4.5s ease-in-out infinite";
container.appendChild(pulse);

var pulseStyle = document.createElement("style");
pulseStyle.innerHTML = "@keyframes slxShowPulse{0%{transform:translate(-50%,-50%) scale(.92);opacity:.35;}50%{transform:translate(-50%,-50%) scale(1.08);opacity:.9;}100%{transform:translate(-50%,-50%) scale(.92);opacity:.35;}}";
document.head.appendChild(pulseStyle);

/* =========================================================
ATMOSPHERE
========================================================= */

var particles = new THREE.Group();
scene.add(particles);

for(var i=0;i<95;i++){
var p = new THREE.Mesh(
new THREE.SphereGeometry(Math.random()*0.045 + 0.014,8,8),
new THREE.MeshBasicMaterial({
color:0x8ef0ff,
transparent:true,
opacity:Math.random()*0.30
})
);
p.position.set((Math.random()-0.5)*32,Math.random()*10,(Math.random()-0.5)*32);
particles.add(p);
}

function beam(x,z,s,color,opacity){
var b = new THREE.Mesh(
new THREE.ConeGeometry(1.5*s,12*s,36,1,true),
new THREE.MeshBasicMaterial({
color:color,
transparent:true,
opacity:opacity,
side:THREE.DoubleSide
})
);
b.position.set(x,4,z);
b.rotation.x = Math.PI;
scene.add(b);
return b;
}

var beam1 = beam(-10,-5,1,0x6be8ff,0.08);
var beam2 = beam(10,-5,1,0x6be8ff,0.08);
var beam3 = beam(0,9,0.9,0x6be8ff,0.1);

/* =========================================================
SIGNAL GRID
========================================================= */

var signalGrid = new THREE.Group();
scene.add(signalGrid);

function signalLine(x1,z1,x2,z2,color,opacity){
var material = new THREE.LineBasicMaterial({
color:color,
transparent:true,
opacity:opacity || 0.24
});
var points = [new THREE.Vector3(x1,0.55,z1),new THREE.Vector3(x2,0.55,z2)];
var geometry = new THREE.BufferGeometry().setFromPoints(points);
var line = new THREE.Line(geometry,material);
signalGrid.add(line);
}

signalLine(-15,-6,15,5,0x00d4ff,.25);
signalLine(-10,8,9,-8,0x6be8ff,.22);
signalLine(-14,3,14,3,0x7ce7ff,.20);
signalLine(-7,-10,12,10,0x00d4ff,.15);

/* =========================================================
TRUCK GROUP
========================================================= */

var truck = new THREE.Group();
scene.add(truck);

/* Main trailer with edge trim */
bevelBox(truck,11,3,3.4,4.8,0.15,0,titanBody);
box(truck,11.15,0.10,3.55,4.8,1.74,0,chrome);
box(truck,11.15,0.08,0.08,4.8,-1.25,1.76,glowMat);
box(truck,11.15,0.08,0.08,4.8,-1.25,-1.76,glowMat);

/* Trailer rear cap / reflective strip */
box(truck,0.08,2.75,3.1,10.35,0.08,0,darkTrim);
box(truck,0.09,0.10,1.1,10.42,-0.85,1.15,redMat);
box(truck,0.09,0.10,1.1,10.42,-0.85,-1.15,redMat);

/* Sleeper and cab */
bevelBox(truck,2.35,3.25,3.15,-1.95,0.45,0,titanBody);
bevelBox(truck,2.85,3.18,3.08,-4.28,0.40,0,darkTrim);

/* Aerodynamic roof fairing */
var fairing = new THREE.Mesh(new THREE.ConeGeometry(1.7,1.8,4,1,false),titanBody);
fairing.rotation.y = Math.PI/4;
fairing.scale.set(1.2,.42,1.15);
fairing.position.set(-3.0,2.25,0);
addTo(truck,fairing);

/* Hood / nose with aero wedge */
var nose = new THREE.Mesh(new THREE.CapsuleGeometry(1.22,2.45,10,22),titanBody);
nose.rotation.z = Math.PI/2;
nose.position.set(-6.25,-0.12,0);
addTo(truck,nose);

var wedgeGeo = new THREE.ConeGeometry(1.35,2.6,4,1,false);
var wedge = new THREE.Mesh(wedgeGeo,titanBody);
wedge.rotation.z = Math.PI/2;
wedge.rotation.y = Math.PI/4;
wedge.scale.set(1.05,.55,1.05);
wedge.position.set(-6.6,-0.52,0);
addTo(truck,wedge);

/* Grille and bumper */
box(truck,0.16,1.52,1.88,-7.8,-0.18,0,chrome);
box(truck,0.28,0.25,2.9,-7.55,-1.03,0,chrome);

/* Windshield and side glass */
box(truck,0.12,1.45,2.44,-4.82,1.05,0,glass);
box(truck,0.78,0.72,0.08,-4.08,1.02,1.57,glass);
box(truck,0.78,0.72,0.08,-4.08,1.02,-1.57,glass);

/* Door lines / side seams */
box(truck,0.035,1.85,0.05,-3.55,0.35,1.61,chrome);
box(truck,0.035,1.85,0.05,-3.55,0.35,-1.61,chrome);
box(truck,0.035,2.4,0.05,-0.82,0.32,1.64,chrome);
box(truck,0.035,2.4,0.05,-0.82,0.32,-1.64,chrome);

/* Side fairings / skirts */
box(truck,5.2,0.22,0.15,2.7,-1.18,1.82,titanBody);
box(truck,5.2,0.22,0.15,2.7,-1.18,-1.82,titanBody);
box(truck,2.2,0.22,0.15,-4.35,-1.18,1.72,titanBody);
box(truck,2.2,0.22,0.15,-4.35,-1.18,-1.72,titanBody);

/* Fuel tanks */
cyl(truck,.42,.42,2.1,32,-1.08,-1.0,1.86,chrome,Math.PI/2);
cyl(truck,.42,.42,2.1,32,-1.08,-1.0,-1.86,chrome,Math.PI/2);

/* Exhaust */
cyl(truck,.14,.14,3.8,20,-1.82,1.95,1.47,chrome,0);
cyl(truck,.14,.14,3.8,20,-1.82,1.95,-1.47,chrome,0);

/* Mirrors */
box(truck,.10,.60,.82,-4.95,.92,1.92,chrome);
box(truck,.10,.60,.82,-4.95,.92,-1.92,chrome);

/* Wheel arches */
function wheelArch(x,z){
var arch = new THREE.Mesh(new THREE.TorusGeometry(0.94,0.11,12,32,Math.PI),darkTrim);
arch.rotation.z = Math.PI/2;
arch.position.set(x,-1.18,z);
addTo(truck,arch);
}
wheelArch(-5.2,1.78);
wheelArch(-5.2,-1.78);

/* Wheels */
function wheel(x,z){
cyl(truck,.82,.82,.62,36,x,-1.45,z,tire,Math.PI/2);
cyl(truck,.34,.34,.64,24,x,-1.45,z,chrome,Math.PI/2);
}
wheel(-5.2,1.78); wheel(-5.2,-1.78);
wheel(-.45,1.78); wheel(-.45,-1.78);
wheel(3.15,1.78); wheel(3.15,-1.78);
wheel(6.75,1.78); wheel(6.75,-1.78);

/* Headlights + beams */
function headlight(z){
box(truck,.22,.12,.55,-7.95,-0.42,z,whiteMat);
var hb = new THREE.Mesh(
new THREE.ConeGeometry(.55,6.8,18,1,true),
new THREE.MeshBasicMaterial({
color:0xc8f8ff,
transparent:true,
opacity:.085,
side:THREE.DoubleSide
})
);
hb.rotation.z = Math.PI/2;
hb.position.set(-10.7,-0.42,z);
truck.add(hb);
}
headlight(1.0);
headlight(-1.0);

/* Marker lights */
function marker(x,z){ box(truck,.18,.08,.18,x,2.72,z,amberMat); }
marker(-4.9,-1.0); marker(-4.7,0); marker(-4.9,1.0);
marker(-2.1,-1.1); marker(-2.1,1.1);
marker(0.5,-1.35); marker(0.5,1.35);

/* Rear marker lights */
box(truck,.10,.10,.25,10.45,1.2,1.34,amberMat);
box(truck,.10,.10,.25,10.45,1.2,-1.34,amberMat);

/* Underglow bars */
var glowBars = [];
function glowBar(w,x,z,color){
var g = box(truck,w,.07,.08,x,-1.30,z,new THREE.MeshBasicMaterial({color:color}));
glowBars.push(g);
}
glowBar(9.9,4.8,1.86,0x12dcff);
glowBar(9.9,4.8,-1.86,0x12dcff);
glowBar(3.2,-5.2,1.68,0x12dcff);
glowBar(3.2,-5.2,-1.68,0x12dcff);

/* =========================================================
CAMERA MODE BUTTONS
========================================================= */

var mode = "orbit";

function addModeButton(label,value,left){
var btn = document.createElement("button");
btn.innerHTML = label;
btn.style.position = "absolute";
btn.style.top = "86px";
btn.style.left = left;
btn.style.zIndex = "99";
btn.style.padding = "10px 16px";
btn.style.borderRadius = "14px";
btn.style.border = "1px solid rgba(120,220,255,.18)";
btn.style.background = "rgba(5,12,22,.82)";
btn.style.color = "#dff7ff";
btn.style.fontWeight = "900";
btn.style.letterSpacing = "1px";
btn.style.cursor = "pointer";
btn.style.backdropFilter = "blur(10px)";
btn.onclick = function(){mode = value;};
container.appendChild(btn);
}

addModeButton("ORBIT","orbit","44%");
addModeButton("DRIVER","driver","52%");
addModeButton("LOW","low","61%");
addModeButton("CINE","cine","68%");

/* =========================================================
INTERACTIONS
========================================================= */

var titanMode = false;
var targetRot = -0.42;
var idle = true;

truck.rotation.y = targetRot;

renderer.domElement.addEventListener("pointermove",function(e){
if(e.buttons !== 1) return;
idle = false;
targetRot += e.movementX * 0.012;
});

renderer.domElement.addEventListener("pointerup",function(){
setTimeout(function(){idle = true;},1200);
});

var glowBtn = document.getElementById("slxGlowToggle");
if(glowBtn){
glowBtn.addEventListener("click",function(){
for(var i=0;i<glowBars.length;i++){
glowBars[i].visible = !glowBars[i].visible;
}
});
}

var upgrade = document.getElementById("slxUpgradeTruck");
if(upgrade){
upgrade.addEventListener("click",function(){
truck.scale.x += .018;
truck.scale.y += .018;
truck.scale.z += .018;
cyan.intensity += .28;
});
}

var activate = document.getElementById("slxActivateTruck");
if(activate){
activate.addEventListener("click",function(){
titanBody.emissive = new THREE.Color(0x00d4ff);
titanBody.emissiveIntensity = .42;
setTimeout(function(){titanBody.emissiveIntensity = .12;},1200);
});
}

var colorButtons = document.querySelectorAll(".slxColor");
for(var cb=0;cb<colorButtons.length;cb++){
colorButtons[cb].onclick = function(){
var c = this.getAttribute("data-color");
if(c === "black"){titanBody.color.set(0x121b25);darkTrim.color.set(0x070b10);}
if(c === "blue"){titanBody.color.set(0x123d63);darkTrim.color.set(0x081d31);}
if(c === "red"){titanBody.color.set(0x661515);darkTrim.color.set(0x2b0808);}
if(c === "gold"){titanBody.color.set(0x705015);darkTrim.color.set(0x2b1d07);}
if(c === "glow"){titanBody.emissive = new THREE.Color(0x00d4ff);titanBody.emissiveIntensity=.42;}
};
}

var tiles = document.querySelectorAll(".slxTruckTile");
for(var ti=0;ti<tiles.length;ti++){
tiles[ti].onclick = function(){
var txt = this.innerText || "";
if(txt.indexOf("TITAN") > -1){
titanMode = true;
redAlert.intensity = 7;
outerRing.material.color.set(0xff3030);
beam1.material.color.set(0xff3030);
beam2.material.color.set(0xff3030);
beam3.material.color.set(0xff3030);
for(var g=0;g<glowBars.length;g++){glowBars[g].material.color.set(0xff3030);}
}else{
titanMode = false;
redAlert.intensity = 0;
outerRing.material.color.set(0x00d4ff);
beam1.material.color.set(0x6be8ff);
beam2.material.color.set(0x6be8ff);
beam3.material.color.set(0x6be8ff);
for(var gg=0;gg<glowBars.length;gg++){glowBars[gg].material.color.set(0x12dcff);}
}
};
}

/* =========================================================
ANIMATION
========================================================= */

var clock = new THREE.Clock();

function animate(){
requestAnimationFrame(animate);

var t = clock.getElapsedTime();

if(idle){targetRot += .0022;}

truck.rotation.y += (targetRot - truck.rotation.y)*.08;
truck.position.y = Math.sin(t*1.4)*.03;

if(mode === "orbit"){
camera.position.x = Math.sin(t*.22)*.85;
camera.position.y = 4.9;
camera.position.z = 20;
}

if(mode === "driver"){
camera.position.x = -5.8;
camera.position.y = 1.8;
camera.position.z = 0;
}

if(mode === "low"){
camera.position.x = 0;
camera.position.y = 1.1;
camera.position.z = 12;
}

if(mode === "cine"){
camera.position.x = Math.sin(t*.12)*2.3;
camera.position.y = 6.4;
camera.position.z = 24;
}

camera.lookAt(0,0,0);

outerRing.rotation.z += .004;
innerRing.rotation.z -= .003;

particles.rotation.y += .0007;
signalGrid.rotation.y += .0005;

if(titanMode){redAlert.intensity = 5 + Math.sin(t*4)*2;}

renderer.render(scene,camera);
}

animate();

/* =========================================================
RESIZE
========================================================= */

function resize(){
var nw = container.clientWidth || window.innerWidth;
var nh = container.clientHeight || 720;
camera.aspect = nw/nh;
camera.updateProjectionMatrix();
renderer.setSize(nw,nh);
}

window.addEventListener("resize",resize);
setTimeout(resize,350);
setTimeout(resize,1200);

}

function loadThree(){
installPanelMinimizeSystem();

if(window.THREE){boot();return;}

var s = document.createElement("script");
s.src = "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js";
s.onload = function(){setTimeout(boot,100);};
document.head.appendChild(s);
}

if(document.readyState === "loading"){
document.addEventListener("DOMContentLoaded",loadThree);
}else{
loadThree();
}

})();